"use client";

import { VolumeOff, VolumeUp } from "@ellaandil/ui";
import { IconButton } from "@/components/ui/IconButton";
import { useTranslations } from "@/i18n/client";
import { useVideoAudio } from "./VideoAudioContext";

export interface VideoAudioToggleProps {
	className?: string;
}

/**
 * Mute/unmute control for the videos in the surrounding `VideoAudioProvider`.
 *
 * Render this only when the section actually contains a video — it has no way
 * to tell on its own, and an always-present button that does nothing is worse
 * than no button.
 */
export const VideoAudioToggle = ({ className }: VideoAudioToggleProps) => {
	const t = useTranslations();
	const { muted, toggle } = useVideoAudio();

	return (
		<IconButton
			// Icon shows the current state, label names the action. That pairing
			// is why `aria-pressed` isn't wanted here: with a label that already
			// changes per state, it would announce the state twice.
			icon={muted ? VolumeOff : VolumeUp}
			label={muted ? t("Turn on sound") : t("Turn off sound")}
			variant="overlay"
			darkBg
			size="md"
			onClick={toggle}
			className={className}
		/>
	);
};
